import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import AuthHelperMethods from './components/auth/AuthHelperMethods';
import withAuth from './components/auth/withAuth';
import { withRouterV6 } from './withRouterV6';
import AopApp from './components/aop/AopApp';

const cookies = new Cookies();

class AopWrapper extends Component {
  Auth = new AuthHelperMethods();

  constructor(props) {
    super(props);
    this.state = {
      user: null,
    };
  }

  componentDidMount() {
    const theme = cookies.get('theme') || 'dark';
    document.documentElement.id = theme === 'light' ? 'light' : 'dark';

    const confirm = this.props.confirm;
    if (confirm) {
      this.setState({
        user: {
          email: confirm.email || '',
          name: confirm.name || confirm.email || 'User',
          role: confirm.role || 'user',
          picture: confirm.picture || null,
        },
      });
    }
  }

  render() {
    return <AopApp user={this.state.user} />;
  }
}

export default withRouterV6(withAuth(AopWrapper));
